import api from "@src/api/api";
import Panel from "@src/components/box/Panel";
import ScrollIcons from "@src/components/elements/shared/ScrollIcons";
import SuggestionsCenterItem from "@src/components/elements/sidebar/suggestions/SuggestionsCenterItem";
import { Post } from "@src/utils/post";
import { useQuery } from "@tanstack/react-query";
import { useRef } from "react";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import tw from "twin.macro";

type Props = { key?: string };

type Response = {
  data: Array<Post>;
};

const NewsfeedSuggestions = ({ key }: Props) => {
  const galleryRef = useRef<HTMLDivElement>(null);
  const { t } = useTranslation();
  const posts = useQuery<Response, Error>(["posts"], async () => {
    const { data } = await api.get("/api/v1/feed");
    return data;
  });

  if (!posts.isSuccess) return <></>;

  return (
    <div className="px-3 lg:px-0">
      <Panel title={t("components.panels.popularNews")} mobileBorder={false} key={key}>
        <div className="relative">
          <div className="no-scrollbar flex gap-4 overflow-x-auto" ref={galleryRef}>
            {posts.data.data
              .filter(item => item.media.length > 0)
              .map(item => {
                return (
                  <SuggestionsCenterItem
                    key={item.id}
                    name={""}
                    link={"/news/für_dich?featured=" + item.id}
                    picture={
                      item.media[0].type === "image"
                        ? `${item.media[0].data_url}`
                        : `${item.media[0].data_url}/thumbnail.jpg?height=600&width=600&fit=crop`
                    }
                    imageStyle={tw`rounded-xl w-[150px] h-[150px]`}
                    nameStyle={tw`w-[150px]`}
                  />
                );
              })}
            <NavLink to="/news/">
              <div className="flex h-[150px] w-[100px] flex-col justify-center text-center">
                {t("buttons.showMore")}
              </div>
            </NavLink>
            <ScrollIcons galleryRef={galleryRef} />
          </div>
        </div>
      </Panel>
    </div>
  );
};
export default NewsfeedSuggestions;
